import { Chip } from '@material-ui/core';
import { MoreHorizOutlined } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import PrimaryChip from 'component/customize_chip/primary_chip';
import themes from 'styles/themes';
import ScrollContainer from 'react-indiana-drag-scroll';

export interface ISliderChipProps {
    listChip: any[];
    handleClick: (purpose) => void;
    handleOpenWidget: () => void;
}
const useStyles = makeStyles(() => ({
    filter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '24px 0 0 24px',
    },
    filterSwiperWrapper: {
        display: 'flex',
        flex: 1,
        width: '100%',
        overflowX: 'scroll',
    },
    filterChipWrap: {
        paddingLeft: '6px',
        paddingRight: '6px',
        // flex: 1,
        width: 'auto !important',
        textAlign: 'center',
        '& .MuiChip-root': {
            width: 'auto !important',
        },
    },

    chipFilterOutline: {
        height: 32,
        width: 32,
    },
    chipRoot: {
        backgroundColor: themes.palette.warning['500'],
        corlor: themes.palette.primary.main,
        marginRight: 4,
        width: 'auto !important',
        '&:hover': {
            backgroundColor: themes.palette.warning['200'],
        },
    },
    chipLabel: {
        padding: '0 8px',
        color: 'white',
        fontFamily: 'PoppinsRegular',
        fontSize: 14,
        fontWeight: 400,
    },
    chipIcon: {
        color: 'white',
        marginLeft: 8,
    },
}));
export default function SliderChip(props: ISliderChipProps) {
    const classes = useStyles();
    return (
        <div className={classes.filter}>
            <ScrollContainer className={classes.filterSwiperWrapper}>
                {props.listChip?.slice(0, 4).map((item, index) => {
                    return <PrimaryChip key={index} title={item?.title} handleClick={() => props.handleClick(item)} />;
                })}
                <div className={classes.filterChipWrap}>
                    <Chip
                        classes={{
                            root: classes.chipRoot,
                            label: classes.chipLabel,
                            icon: classes.chipIcon,
                        }}
                        clickable
                        // className={classes.chipRoot}
                        icon={<MoreHorizOutlined style={{ color: `${themes.palette.primary.main}` }} />}
                        onClick={props.handleOpenWidget}
                    />
                </div>
            </ScrollContainer>
        </div>
    );
}
